import { supabase } from '../../lib/supabase';
import type { Community } from '../../types';

export const supabaseCommunityService = {
  getAll: async () => {
    console.log('Fetching communities...'); // Debug log
    
    try {
      const { data, error } = await supabase
        .from('communities')
        .select('*')
        .order('comm_name');

      if (error) {
        console.error('Supabase error:', error); // Debug log
        throw error;
      }

      if (!data) {
        console.log('No communities data returned'); // Debug log
        return [];
      }

      console.log('Communities fetched:', data); // Debug log

      // Return the raw data from Supabase without transforming property names
      // This ensures it matches the database schema exactly
      return data;
    } catch (err) {
      console.error('Error in getAll communities:', err); // Debug log
      throw err;
    }
  }
};
